import { render, staticRenderFns } from "./Affilliates.vue?vue&type=template&id=6ce07f74&"
import script from "./Affilliates.vue?vue&type=script&lang=js&"
export * from "./Affilliates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports